var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlobLogoMedicin = function SvgBlobLogoMedicin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 67"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 142,
    height: 66,
    x: 60,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4DA7B9",
    fillRule: "evenodd",
    d: "M115.695 60.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 28.9 73.349.593 100.877.593c27.528 0 29.235 2.1 62.568.991s50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8CD7E6",
    fillRule: "evenodd",
    d: "M115.695 60.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 28.9 73.349.593 100.877.593c27.528 0 29.235 2.1 62.568.991s50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6FC5D7",
    fillOpacity: 0.8,
    d: "M195.959 14c12 7.5 22.153 56.5-27 56.5s-113.5-7.596-113.5-14.5c-1.798-19.78-9.787-38.741 21.5-46 12.212-2.833 31.33-.377 58-1.5 28.475-1.2 43.5 1.5 61 5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5DB9CC",
    d: "M201.459 22.5c0 6.903 16.653 48-32.5 48s-113.5-7.596-113.5-14.5-3.914-20.006 44.5-28.5c11.611-2.037 30.858-11.205 49-13.5 26.39-3.339 52.5 4.409 52.5 8.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9DA",
    fillRule: "evenodd",
    d: "M72.475 36.366c-.57 16.311-19.4 30.297-35.662 29.73C20.552 65.529.261 57.304.832 40.994 1.402 24.665 25.058 4.165 41.32 4.732c16.668.582 31.724 15.323 31.154 31.634Z",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    }
  }));
};
export default SvgBlobLogoMedicin;